import type { CarrierLogoProps } from './types'
import LogoSvg from '../../assets/carrier-logos/uds-logo.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const UDSLogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function UDSLogo(props, ref) {
    const logoProps = getLogoProps(props, {
      primary: { light: '#1e4691', dark: '#2F6CDD' },
      secondary: { light: '#999999', dark: '#cccccc' },
    })

    return <Logo {...logoProps} ref={ref} />
  },
)
